import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { getSeoForPath } from './seoRegistry';
import usePageSeo from './usePageSeo';

const RouteSeo = () => {
  const { pathname } = useLocation();
  const seo = useMemo(() => getSeoForPath(pathname), [pathname]);
  usePageSeo(seo);
  return null;
};

export default RouteSeo;
